import React from "react";
import { IoMdArrowRoundForward } from "react-icons/io";
import styled from "styled-components";
import { Link } from "react-router-dom";
import FitnessOne from "../images/Gym.png";
import NutritionOne from "../images/BreakfastImage.png";

const Section = styled.section`
  width: 100%;
  height: 100%;
  padding: 10rem calc((100vw - 1300px) / 2);
  display: flex;
  justify-content: center;
`;

const Container = styled.div`
  height: 100%;
  width: 100%;
  padding: 2rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center; /* Center container contents */
`;

const Heading = styled.div`
  font-size: 1.5rem;
  padding: 2rem 1rem;
  margin-bottom: 40px;

  @media screen and (max-width: 768px) {
    text-align: start;
  }
`;

const InfoRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center; /* Center the items horizontally */
  padding: 1rem 0rem;
  gap: 2rem; /* Add spacing between items */

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center; /* Center on smaller screens */
  }
`;

const InfoWrap = styled.div`
  padding: 0rem 1rem;
  min-height: 550px;
  height: 100%;
  text-align: center; /* Center the content inside the wrapper */

  h2 {
    margin-bottom: 1rem;
    font-weight: 400;
  }

  @media screen and (max-width: 768px) {
    margin-bottom: 1rem;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  max-width: 600px;
  max-height: 400px;
  object-fit: cover;
  margin-bottom: 1rem;
  margin-left: auto;
  margin-right: auto; /* Center image */
`;

const InfoLink = styled(Link)`
  display: flex;
  justify-content: center; /* Center the link content */
  align-items: center;
  text-decoration: none;
  color: #000d1a;
  width: 140px;
  margin: 0 auto; /* Center the link */
  transition: 0.3s;

  &:hover {
    transform: translateY(-2px);
  }
`;

const Arrow = styled(IoMdArrowRoundForward)`
  margin-left: 10px;
`;

const Listings = () => {
  return (
    <Section>
      <Container>
        <Heading>
          <h1
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-once="true"
            data-aos-anchor-placement="center bottom"
          >
            Les formules disponibles
          </h1>
        </Heading>
        <InfoRow>
          <InfoWrap
            data-aos="zoom-out-up"
            data-aos-duration="1200"
            data-aos-once="true"
            data-aos-anchor-placement="center bottom"
          >
            <Image src={FitnessOne} alt="home" />
            <h2>Coaching sport</h2>
            <InfoLink to="/coachingtypes">
              <p>Voir les détails</p>
              <Arrow />
            </InfoLink>
          </InfoWrap>
          <InfoWrap
            data-aos="zoom-out-down"
            data-aos-duration="1200"
            data-aos-once="true"
            data-aos-anchor-placement="center bottom"
          >
            <Image
              src={NutritionOne}
              alt="home"
              css={`
                margin-top: 120px;
                @media screen and (max-width: 768px) {
                  margin-top: 0px;
                }
              `}
            />
            <h2>Coaching nutrition</h2>
            <InfoLink to="/coachingtypes">
              <p>Voir les détails</p>
              <Arrow />
            </InfoLink>
          </InfoWrap>
        </InfoRow>
      </Container>
    </Section>
  );
};

export default Listings;
